var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMamaPoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 171,
    viewBox: "0 0 324 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1278_86359)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.667969,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "url(#paint0_linear_1278_86359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 170.668H296.229L129.9 -32.9892H0V170.668Z",
    fill: "url(#paint1_linear_1278_86359)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1278_86359)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144.289,
    cy: 115.578,
    r: 71.3694,
    stroke: "url(#paint2_linear_1278_86359)",
    strokeOpacity: 0.08,
    strokeWidth: 24.1346
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.455,
    cy: -13.7197,
    r: 85.8271,
    stroke: "url(#paint3_linear_1278_86359)",
    strokeOpacity: 0.08,
    strokeWidth: 29.0236
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1278_86359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.32 -4.88641C220.32 52.3745 173.901 98.7936 116.64 98.7936C59.3791 98.7936 12.96 52.3745 12.96 -4.88641C12.96 -62.1473 59.3791 -108.566 116.64 -108.566C173.901 -108.566 220.32 -62.1473 220.32 -4.88641Z",
    fill: "url(#paint4_radial_1278_86359)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 320.856,
    cy: 220.62,
    r: 102.481,
    stroke: "url(#paint5_linear_1278_86359)",
    strokeOpacity: 0.08,
    strokeWidth: 38.6935
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.406 20.9368C390.077 50.8931 375.984 95.3417 339.354 121.84C302.739 148.327 257.285 146.525 235.607 116.557C213.911 86.5658 224.742 39.3686 261.329 12.9017C297.916 -13.5654 346.711 -9.05396 368.406 20.9368Z",
    stroke: "#D28F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.2 8.87529C389.995 44.1844 382.299 86.8782 340.851 120.517C298.174 151.984 251.879 144.393 227.546 113.443C203.213 82.4924 212.137 31.0446 249.927 3.70794C287.716 -23.6287 337.782 -22.1145 360.2 8.87529Z",
    fill: "url(#paint6_linear_1278_86359)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.591 8.09908C364.52 31.5018 355.013 71.7821 319.573 97.4189C284.133 123.056 242.901 119.48 225.972 96.0773C209.042 72.6746 218.549 32.3943 253.989 6.75745C289.429 -18.8794 330.661 -15.3036 347.591 8.09908Z",
    fill: "white",
    stroke: "url(#paint7_linear_1278_86359)",
    strokeWidth: 17.948
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.779 20.937L300.487 63.9232L282.821 50.836L270.546 40.6973L307.779 20.937Z",
    fill: "#F8C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.253 20.5039L301.109 64.3182L282.895 50.825L282.938 50.8572L308.253 20.5039Z",
    fill: "#F4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.779 20.9368L300.488 63.923L282.822 50.8358L282.864 50.867L307.779 20.9368Z",
    fill: "#EB9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.672 62.1064L270.577 40.6557L283.02 50.6569L300.518 63.8815L277.672 62.1064Z",
    fill: "#F4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.672 62.1064L283.02 50.6569L283.02 50.6569L300.518 63.8815L277.672 62.1064Z",
    fill: "#E69898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.035 66.2967L267.71 42.6285L262.716 81.385L276.035 66.2967Z",
    fill: "#F4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.137 65.1547L267.47 43.7166L262.859 80.2688L273.137 65.1547Z",
    fill: "#EB9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.026 65.3844L298.839 67.2101L262.387 81.0843L273.026 65.3844Z",
    fill: "#F4A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.191 65.1953L296.962 67.1329L262.907 80.3049L273.191 65.1953Z",
    fill: "#FFB4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.91 14.4083C346.198 24.4827 347.157 37.85 342.579 51.456C338.001 65.0586 327.916 78.7753 313.354 89.3093C298.792 99.8433 282.608 105.13 268.256 105.22C253.901 105.31 241.505 100.216 234.218 90.1421C226.93 80.0677 225.971 66.7003 230.549 53.0944C235.126 39.4917 245.212 25.775 259.774 15.241C274.335 4.70705 290.519 -0.579367 304.871 -0.66974C319.226 -0.760135 331.622 4.33388 338.91 14.4083Z",
    stroke: "url(#paint8_linear_1278_86359)",
    strokeWidth: 2.87168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.786 47.7271L378.34 64.546C381.61 45.3281 374.46 29.9463 371.65 25.6791C369.426 21.5105 365.3 15.655 360.441 9.23026C347.545 -10.9312 320.361 -28.913 278.102 -15.4855C227.842 1.79951 211.183 42.5309 209.396 60.5165L363.49 45.7579L367.786 47.7271Z",
    fill: "#FDAEB3",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddddd_1278_86359)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5142,
    y: 45.9277,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0648 49.3887L35.8228 58.7653H30.5207L26.6865 58.5629L31.0648 49.3887Z",
    fill: "#BD827F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1278_86359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0947 49.2363L36.0002 58.7522H30.5337H30.5467L31.0947 49.2363Z",
    fill: "#E49E9A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.0651 49.3887L35.8231 58.7653H30.521H30.5337L31.0651 49.3887Z",
    fill: "#E49E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1407 61.6875L26.6865 58.5493L30.5334 58.7011L35.8228 58.7518L31.1407 61.6875Z",
    fill: "#E1A19D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1407 61.6875L30.5334 58.7011L30.5334 58.7011L35.8228 58.7518L31.1407 61.6875Z",
    fill: "#DF8B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4252 62.7352L26.4142 59.3439L31.0102 67.5711L31.4252 62.7352Z",
    fill: "#F4AFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7 62.93L26.5241 59.5893L30.878 67.3343L30.7 62.93Z",
    fill: "#DC9994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.711 62.9908L35.9751 59.6391L30.9032 67.5605L30.711 62.9908Z",
    fill: "#DD9691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7164 62.9299L35.6009 59.893L30.8927 67.3342L30.7164 62.9299Z",
    fill: "#F0ACA9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.9046 64.9277V53.1638H55.7708L60.4031 60.3788H59.4533L64.0689 53.1638H65.9518V64.9277H63.3357V57.5794L63.8023 57.6961L60.7863 62.395H59.0534L56.0541 57.6961L56.504 57.5794V64.9277H53.9046ZM71.3572 65.0944C70.6129 65.0944 69.9464 64.9111 69.3577 64.5445C68.78 64.1779 68.319 63.678 67.9746 63.0448C67.6414 62.4116 67.4748 61.6896 67.4748 60.8787C67.4748 60.0677 67.6414 59.3457 67.9746 58.7125C68.319 58.0793 68.78 57.5794 69.3577 57.2128C69.9464 56.8462 70.6129 56.663 71.3572 56.663C71.9015 56.663 72.3903 56.7685 72.8235 56.9796C73.2679 57.1906 73.6289 57.485 73.9066 57.8627C74.1843 58.2293 74.3399 58.6514 74.3732 59.1291V62.6283C74.3399 63.1059 74.1843 63.5336 73.9066 63.9113C73.64 64.2779 73.2845 64.5667 72.8402 64.7778C72.3959 64.9888 71.9015 65.0944 71.3572 65.0944ZM71.8738 62.7949C72.4181 62.7949 72.8569 62.6172 73.1901 62.2617C73.5234 61.8951 73.69 61.4341 73.69 60.8787C73.69 60.501 73.6122 60.1677 73.4567 59.8789C73.3123 59.5901 73.1013 59.3679 72.8235 59.2124C72.5569 59.0457 72.2459 58.9624 71.8904 58.9624C71.5349 58.9624 71.2184 59.0457 70.9406 59.2124C70.674 59.3679 70.4574 59.5901 70.2908 59.8789C70.1353 60.1677 70.0575 60.501 70.0575 60.8787C70.0575 61.2452 70.1353 61.5729 70.2908 61.8618C70.4463 62.1506 70.6629 62.3783 70.9406 62.5449C71.2184 62.7116 71.5294 62.7949 71.8738 62.7949ZM73.59 64.9277V62.7449L73.9733 60.7787L73.59 58.8125V56.8296H76.0895V64.9277H73.59ZM77.8845 64.9277V56.8296H80.4339V64.9277H77.8845ZM83.0666 64.9277V60.1955C83.0666 59.7845 82.9389 59.4679 82.6834 59.2457C82.439 59.0124 82.1335 58.8958 81.7669 58.8958C81.5114 58.8958 81.2837 58.9513 81.0838 59.0624C80.8838 59.1624 80.7227 59.3068 80.6005 59.4956C80.4895 59.6845 80.4339 59.9178 80.4339 60.1955L79.4508 59.7622C79.4508 59.118 79.5897 58.5681 79.8674 58.1126C80.1451 57.6461 80.5228 57.2906 81.0004 57.0462C81.4781 56.7907 82.0169 56.663 82.6167 56.663C83.1833 56.663 83.6887 56.7907 84.1331 57.0462C84.5885 57.3017 84.9495 57.6572 85.2162 58.1126C85.4828 58.5681 85.6161 59.1124 85.6161 59.7456V64.9277H83.0666ZM88.2488 64.9277V60.1955C88.2488 59.7845 88.121 59.4679 87.8655 59.2457C87.6212 59.0124 87.3157 58.8958 86.9491 58.8958C86.6936 58.8958 86.4659 58.9513 86.2659 59.0624C86.066 59.1624 85.9049 59.3068 85.7827 59.4956C85.6716 59.6845 85.6161 59.9178 85.6161 60.1955L84.1497 59.9955C84.1719 59.3068 84.333 58.718 84.633 58.2293C84.944 57.7294 85.3495 57.3461 85.8493 57.0795C86.3603 56.8018 86.9324 56.663 87.5656 56.663C88.1877 56.663 88.7376 56.7963 89.2152 57.0629C89.704 57.3184 90.0873 57.6905 90.365 58.1793C90.6538 58.6569 90.7982 59.2346 90.7982 59.9122V64.9277H88.2488ZM95.8145 65.0944C95.0702 65.0944 94.4037 64.9111 93.815 64.5445C93.2373 64.1779 92.7763 63.678 92.4319 63.0448C92.0987 62.4116 91.9321 61.6896 91.9321 60.8787C91.9321 60.0677 92.0987 59.3457 92.4319 58.7125C92.7763 58.0793 93.2373 57.5794 93.815 57.2128C94.4037 56.8462 95.0702 56.663 95.8145 56.663C96.3588 56.663 96.8476 56.7685 97.2808 56.9796C97.7252 57.1906 98.0862 57.485 98.3639 57.8627C98.6416 58.2293 98.7972 58.6514 98.8305 59.1291V62.6283C98.7972 63.1059 98.6416 63.5336 98.3639 63.9113C98.0973 64.2779 97.7418 64.5667 97.2975 64.7778C96.8532 64.9888 96.3588 65.0944 95.8145 65.0944ZM96.3311 62.7949C96.8754 62.7949 97.3142 62.6172 97.6474 62.2617C97.9807 61.8951 98.1473 61.4341 98.1473 60.8787C98.1473 60.501 98.0695 60.1677 97.914 59.8789C97.7696 59.5901 97.5586 59.3679 97.2808 59.2124C97.0142 59.0457 96.7032 58.9624 96.3477 58.9624C95.9922 58.9624 95.6757 59.0457 95.3979 59.2124C95.1313 59.3679 94.9147 59.5901 94.7481 59.8789C94.5926 60.1677 94.5148 60.501 94.5148 60.8787C94.5148 61.2452 94.5926 61.5729 94.7481 61.8618C94.9036 62.1506 95.1202 62.3783 95.3979 62.5449C95.6757 62.7116 95.9867 62.7949 96.3311 62.7949ZM98.0473 64.9277V62.7449L98.4306 60.7787L98.0473 58.8125V56.8296H100.547V64.9277H98.0473ZM107.748 60.6454V58.6125H110.28C110.603 58.6125 110.897 58.5459 111.164 58.4126C111.43 58.2793 111.641 58.0849 111.797 57.8294C111.952 57.5739 112.03 57.2628 112.03 56.8962C112.03 56.5408 111.952 56.2353 111.797 55.9798C111.641 55.7243 111.43 55.5299 111.164 55.3966C110.897 55.2633 110.603 55.1966 110.28 55.1966H107.748V53.1638H110.664C111.408 53.1638 112.08 53.3137 112.68 53.6137C113.28 53.9136 113.752 54.3468 114.096 54.9134C114.452 55.4688 114.629 56.1297 114.629 56.8962C114.629 57.6627 114.452 58.3292 114.096 58.8958C113.752 59.4512 113.28 59.8844 112.68 60.1955C112.08 60.4954 111.408 60.6454 110.664 60.6454H107.748ZM105.748 64.9277V53.1638H108.364V64.9277H105.748ZM119.535 65.111C118.702 65.111 117.947 64.9277 117.269 64.5612C116.603 64.1835 116.075 63.6725 115.686 63.0282C115.297 62.3839 115.103 61.6618 115.103 60.862C115.103 60.0622 115.297 59.3457 115.686 58.7125C116.075 58.0793 116.603 57.5794 117.269 57.2128C117.936 56.8351 118.691 56.6463 119.535 56.6463C120.38 56.6463 121.135 56.8296 121.802 57.1962C122.468 57.5628 122.996 58.0682 123.385 58.7125C123.773 59.3457 123.968 60.0622 123.968 60.862C123.968 61.6618 123.773 62.3839 123.385 63.0282C122.996 63.6725 122.468 64.1835 121.802 64.5612C121.135 64.9277 120.38 65.111 119.535 65.111ZM119.535 62.7949C119.902 62.7949 120.224 62.7171 120.502 62.5616C120.78 62.395 120.991 62.1673 121.135 61.8784C121.291 61.5785 121.368 61.2397 121.368 60.862C121.368 60.4843 121.291 60.1566 121.135 59.8789C120.98 59.5901 120.763 59.3679 120.485 59.2124C120.219 59.0457 119.902 58.9624 119.535 58.9624C119.18 58.9624 118.863 59.0457 118.586 59.2124C118.308 59.3679 118.091 59.5901 117.936 59.8789C117.78 60.1677 117.702 60.501 117.702 60.8787C117.702 61.2452 117.78 61.5785 117.936 61.8784C118.091 62.1673 118.308 62.395 118.586 62.5616C118.863 62.7171 119.18 62.7949 119.535 62.7949ZM125.237 64.9277V56.8296H127.786V64.9277H125.237ZM126.52 55.7132C126.12 55.7132 125.787 55.5799 125.52 55.3133C125.265 55.0356 125.137 54.7023 125.137 54.3135C125.137 53.9136 125.265 53.5803 125.52 53.3137C125.787 53.0471 126.12 52.9138 126.52 52.9138C126.92 52.9138 127.248 53.0471 127.503 53.3137C127.759 53.5803 127.886 53.9136 127.886 54.3135C127.886 54.7023 127.759 55.0356 127.503 55.3133C127.248 55.5799 126.92 55.7132 126.52 55.7132ZM134.93 64.9277V60.3121C134.93 59.89 134.797 59.5512 134.531 59.2957C134.275 59.0291 133.947 58.8958 133.547 58.8958C133.27 58.8958 133.025 58.9569 132.814 59.0791C132.603 59.1902 132.437 59.3568 132.314 59.579C132.192 59.79 132.131 60.0344 132.131 60.3121L131.148 59.8289C131.148 59.1957 131.287 58.6403 131.565 58.1626C131.842 57.6849 132.225 57.3184 132.714 57.0629C133.214 56.7963 133.775 56.663 134.397 56.663C134.997 56.663 135.525 56.8074 135.98 57.0962C136.447 57.3739 136.813 57.746 137.08 58.2126C137.347 58.6792 137.48 59.1902 137.48 59.7456V64.9277H134.93ZM129.582 64.9277V56.8296H132.131V64.9277H129.582Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.16797,
    width: 323,
    height: 169.331,
    rx: 11.5343,
    stroke: "url(#paint9_linear_1278_86359)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1278_86359",
    x: -46.6972,
    y: -168.224,
    width: 326.674,
    height: 326.675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.8286,
    result: "effect1_foregroundBlur_1278_86359"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddddd_1278_86359",
    x: -57.4858,
    y: 19.9277,
    width: 177,
    height: 177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.38363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05156
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.037943 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1278_86359"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.32505
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52704
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0479222 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1278_86359",
    result: "effect2_dropShadow_1278_86359"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.26078
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.75819
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0544001 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1278_86359",
    result: "effect3_dropShadow_1278_86359"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.1682
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.4878
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0602938 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1278_86359",
    result: "effect4_dropShadow_1278_86359"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20.8888
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.8755
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0681504 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1278_86359",
    result: "effect5_dropShadow_1278_86359"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 50
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_1278_86359",
    result: "effect6_dropShadow_1278_86359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_1278_86359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1278_86359",
    x: 30.5337,
    y: 49.2363,
    width: 5.4668,
    height: 9.51562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9 0 0 0 0 0.799632 0 0 0 0 0.795 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1278_86359"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1278_86359",
    x1: 54.6171,
    y1: -7.46148,
    x2: 188.809,
    y2: 205.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491094,
    stopColor: "#F2A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692555,
    stopColor: "#DE8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD8989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1278_86359",
    x1: 239.76,
    y1: 154.005,
    x2: 44.0917,
    y2: 9.40735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE56",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFEF",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1278_86359",
    x1: 144.289,
    y1: 32.1416,
    x2: 129.981,
    y2: 195.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1278_86359",
    x1: 375.649,
    y1: -73.4255,
    x2: 296.248,
    y2: 82.8876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.520347,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1278_86359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.64 -4.88641) rotate(90) scale(103.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F10000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1278_86359",
    x1: 235.778,
    y1: 197.463,
    x2: 215.641,
    y2: 175.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1278_86359",
    x1: 251.578,
    y1: 2.5131,
    x2: 338.287,
    y2: 122.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1278_86359",
    x1: 318.478,
    y1: -20.9754,
    x2: 263.751,
    y2: 125.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1278_86359",
    x1: 259.655,
    y1: 11.132,
    x2: 318.571,
    y2: 89.1705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopColor: "#F6A5A6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1278_86359",
    x1: 12,
    y1: -30.5006,
    x2: 294,
    y2: 226.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#CA7675",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#CA7675",
    stopOpacity: 0.0137778
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA7675",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1278_86359"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.667969,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1278_86359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525.072,
    height: 456.507,
    fill: "white",
    transform: "translate(-82.3887 -114.059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMamaPoin);
export default __webpack_public_path__ + "static/media/mama-poin.165c893ff4e67ee158507f66730efce3.svg";
export { ForwardRef as ReactComponent };